export default __webpack_public_path__ + "CircularCustCapNum-BlackItalic.a4ea6601151a884e3c33ff270eee8e4e.eot";